import { INTENT_TYPE } from '../../constants';
import { type IntentMatcher } from '../../types';

/**
 * PORTED FROM: the first branch of `GninHeuristicStrategy.classifyInternal`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/services/strategy/GninHeuristicStrategy.java#lines-65
 *
 * ```java
 * if (trimmedQuery.isEmpty()) {
 *     return new JiraClassificationResult(GNIN, EMPTY);
 * }
 * ```
 *
 * Empty input routing to GNIN rather than search looks odd out of context, but
 * it is what upstream does: with nothing to search for, Jira sends the user to
 * the navigation experience.
 *
 * This must run first. `isJql` also returns `true` for blank input, so if the
 * JQL matcher went first an empty query would be reported as `GNIN/JQL`.
 */
export const emptyMatcher: IntentMatcher = {
	pattern: 'EMPTY',
	type: INTENT_TYPE.GNIN,
	matches: (input: string): boolean => input.trim().length === 0,
};
